export const USER_PREFERENCE_LOCAL_STORAGE = {
  LAST_UPDATED: "preferenceLastUpdated",
  SIGNED_URL_PARAMS: "preferenceSignedUrlParams",
};
